

































import { createComponent } from "@vue/composition-api";
import { useRouting } from "@dcc/compositions/useRouting";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { BaseWelcomePanel } from "@web-components";

export default createComponent({
  components: {
    BaseWelcomePanel
  },
  setup(props: {}, context) {
    const { handleNext } = useRouting(context);
    const dictionary = useDictionary();

    return {
      handleNext,
      ...dictionary
    };
  }
});
